import * as React from 'react';
import { useEffect } from 'react';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { accountsSelector, accountsByIdStatusSelector } from '../account/account-selectors';
import { loadAccounts } from '../account/actions/load-accounts';
import { userSelector } from '../reducers/current-user-selectors';
import { lastVisitedOrgIdSelector } from '../reducers/display-settings-selectors';

import { HOME_ROUTE, employeesRoute, orgSettingsRoute } from '../web-routes';

import { LoadingMessage } from '../widgets/loading-message';

const mapStateToProps = (state: any) => {
  const user = userSelector(state);

  // Most users coming into the account page will have these filled in
  const lastVisitedOrgId = user.username ? lastVisitedOrgIdSelector(state, user.username) : null;

  // However if they don't, we need to look in the accounts they have access to and pick the first one
  // because we don't know where they are coming from
  const accounts = accountsSelector(state);
  const accountState = accountsByIdStatusSelector(state);

  return {
    user,
    accounts,
    accountState,
    lastVisitedOrgId,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    loadAccounts: () => dispatch(loadAccounts()),
  },
});

export const HelpscoutRedirect = () => {
  const { type } = useParams<{ type: string }>();
  const history = useHistory();

  const { accounts, accountState, lastVisitedOrgId } = useSelector(mapStateToProps, shallowEqual);
  const { actions } = mapDispatchToProps(useDispatch());

  useEffect(() => {
    actions.loadAccounts();
  });

  if (accountState?.loading || !accounts || !accounts.length) {
    return <LoadingMessage />;
  }

  const orgIdToRedirectTo = lastVisitedOrgId || accounts[0]?.Organizations[0]?.org_id;
  if (!orgIdToRedirectTo) {
    history.replace(HOME_ROUTE);
  }

  let route = null;
  switch (type) {
    case 'hris-registration':
      route = employeesRoute(orgIdToRedirectTo, { openHrisDialog: true });
      break;
    case 'company-settings':
      route = orgSettingsRoute(orgIdToRedirectTo);
      break;
    default:
      break;
  }

  if (route) {
    history.replace(route);
  } else {
    history.replace(HOME_ROUTE);
  }

  // Line 75 makes it impossible to get here
  return null;
};
